module.exports = __webpack_public_path__ + "static/group-of-people-working-out-business-plan-in-an-office-71a3771d08a7ecc11141d759eccd3d47.jpg";